export default __webpack_public_path__ + "static/media/brand-image-05.cdef521e.jpg";